import React from 'react';
import {Card} from "antd";
import BidForm from "./BidForm";
import {compose} from "redux";
import {connect} from "react-redux";
import {withLoading} from "../Boilerplate/deferLoaderHoc";
import {getBid, updateBid} from "../../actions/bids";

const BidEdit = props => {
  const { bid, codes, onSubmit, onCancel } = props;
  return <Card title='Bid Details' className={'edit-view'}>
    <BidForm bid={bid} codes={codes} onCancel={onCancel} onSubmit={onSubmit}/>
  </Card>;
};

export default compose(
  connect(
    (state, props) => {
      let bid = state.view.data[props.match.params.bidId];
      if (!bid) return { loading: true };
      return { bid: bid.resource };
    },
    (dispatch, props) => ({
      loader: () => dispatch(getBid(props.match.params.bidId)),
      onSubmit: (bid) => {
        dispatch(updateBid(bid));
        props.history.goBack();
      },
      onCancel: () => props.history.goBack()
    })
  ),
  withLoading
)(BidEdit);



// WEBPACK FOOTER //
// ./src/components/Bids/BidEdit.js